/* Shared form and panel styles for the lab-management pages (experiments,
   protocols, quality, scan station, MLOps, activity), on the theme tokens only
   (src/theme/tokens.css): no literal colours, so both themes and both contrast
   checks hold. */
export const box = {
  border: '1px solid var(--c-border)', borderRadius: 8, padding: 16,
  marginBottom: 16, background: 'var(--c-surface)',
};
export const label = { display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 10, fontSize: 14 };
export const input = {
  padding: '6px 8px', border: '1px solid var(--c-border)', borderRadius: 6,
  fontSize: 14, background: 'var(--c-surface)', color: 'var(--c-text-fg)',
};
export const mono = { fontFamily: 'ui-monospace, SFMono-Regular, Consolas, monospace', fontSize: 12 };
export const button = (bg) => ({
  background: bg, color: 'var(--c-on-accent)', border: 'none', borderRadius: 6,
  padding: '8px 16px', cursor: 'pointer', fontSize: 14, marginInlineEnd: 8,
});
export const badge = (tone) => ({
  display: 'inline-block', padding: '1px 8px', borderRadius: 10, fontSize: 12,
  background: `var(--c-${tone}-soft)`, color: `var(--c-${tone}-fg)`, marginInlineStart: 6,
});
